import _ from 'lodash'
import moment from 'moment'
import React, { Component } from 'react'
import {clearFields, formValueSelector} from 'redux-form'
import { connect } from 'react-redux'
import { goBack, push } from 'react-router-redux'

import { clearDefectErrors, createDefect, setDefectCurrentField, setDefectErrors } from '../actions/defect'
import {
    clearDefectAreaKey, createDefectArea,
    listDefectAreas,
    setDefectAreaIsLoading,
    setDefectAreaSelected,
    setIsAddDefectArea,
    clearDefectAreaErrors,
    setDefectAreaErrors
} from '../actions/defect-area'
import { clearFile, setFiles } from '../actions/file'
import {
    clearMainAreaErrors, clearMainAreaKey, createMainArea, listMainAreas, setMainAreaErrors, setMainAreaIsLoading,
    setMainAreaSelected, setIsAddMainArea
} from '../actions/main-area'
import { listProjects, getUserFromProject } from '../actions/project'
import { clearUserKey, listUsers, setUserIsLoading, setUserSelected } from '../actions/user'

import DefectAdd from '../components/DefectAdd'

class DefectAddPage extends Component {
  componentDidMount () {
    const { clearDefectErrors, listProjects, clearMainAreaKey, clearDefectAreaKey, clearUserKey, clearFile } = this.props
    clearDefectErrors()
    listProjects({ limit: -1 })
    clearMainAreaKey('mainArea')
    clearDefectAreaKey('defectArea')
    clearUserKey('assigneeUser')
    clearFile('defect-add')
    clearFile('defect-add-data')
    clearMainAreaKey('mainAreaId')
  }

  render () {
    return (<DefectAdd {...this.props}/>)
  }
}

const selector = formValueSelector('defect-add')

const mapStateToProps = (state, ownProps) => {
  console.log('HHHH', state)
  const { current } = state.defect
  const projects = _.get(state, 'project.project.list.rows', [])
  const props = {
    errors: _.get(state, 'defect.errors', {}),
    authorUserId: state.auth.id,
    projects,
    users: _.get(state, 'project.users') ,
    projectId: selector(state, 'projectId'),
    mainAreaId: _.get(state, 'mainArea.mainAreaId'),
    mainArea: _.get(state, 'mainArea.mainArea', {
      isLoading: false,
      list: { rows: [] },
      selected: [],
      defaultSelected: [],
    }),
    defectArea: _.get(state, 'defectArea.defectArea', {
      isLoading: false,
      list: { rows: [] },
      selected: [],
      defaultSelected: []
    }),
    assignee: _.get(state, 'user.assignee', {
      isLoading: false,
      list: { rows: [] },
      selected: [],
      defaultSelected: []
    }),
    initialValues: {
      status: 'OPEN',
    },
    // expectedDeliveryDate: moment().add(7, 'day'),
    images: state.file['defect-add'],
    imageData: state.file['defect-add-data'],
    newMainArea: _.get(state, 'mainArea.newMainArea'),
    mainAreaErrors: _.get(state, 'mainArea.errors'),
    defectAreaErrors: _.get(state, 'defectArea.errors'),
    mainAreaList: _.get(state, 'mainArea.list'),
    defectAreaList: _.get(state, 'defectArea.list')
  }
  if (projects.length === 1) {
    props.projectId = projects[0].id
  }
  // if (current) {
  //   props.expectedDeliveryDate = current.expectedDeliveryDate ? moment(current.expectedDeliveryDate) : undefined
  // }
  return props
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  async onSubmit (values, authorUserId, mainArea, defectArea, assignee, images) {
    const errors = {}
    if (!values.projectId) {
      errors.projectId = 'Project is required.'
    }
    if (!mainArea) {
      errors.mainArea = 'Main Area is required.'
    }
    if (!defectArea) {
      errors.defectArea = 'Defect Area is required.'
    }
    if (!assignee) {
      errors.assignee = 'Assignee is required.'
    }
    if (!values.detail) {
      errors.detail = 'Detail is required.'
    }
    if (values.detail.length > 500) {
      errors.detail = 'Detail should not longer that 500 characters.'
    }
    // if (!expectedDeliveryDate || !expectedDeliveryDate.isValid()) {
    //   errors.expectedDeliveryDate = 'Expected Delivery Date is required.'
    // }
    if (!_.isEmpty(errors)) {
      dispatch(setDefectErrors(errors))
      return
    }
    dispatch(clearDefectErrors())
    await dispatch(createDefect({
      ...values,
      authorUserId,
      defectAreaId: defectArea.id,
      assigneeUserId: assignee.id,
    }, images))
    dispatch(push('/defect'))
  },
  clearDefectErrors () {
    dispatch(clearDefectErrors())
  },
  uploadImage (event) {
    const { files } = event.target
    dispatch(setFiles('defect-add', files))
    _.forEach(files, (file) => {
      const reader = new FileReader()
      reader.onloadend = (event) => {
        dispatch(setFiles('defect-add-data', [event.target.result]))
      }
      reader.readAsDataURL(file)
    })
  },
  clearFile (key) {
    dispatch(clearFile(key))
  },
  listProjects (query) {
    dispatch(listProjects(query, 'project'))
  },
  async searchMainArea (name, projectId, key) {
    dispatch(setMainAreaIsLoading(true, key))
    await dispatch(listMainAreas({ name, projectId }, key))
    dispatch(setMainAreaIsLoading(false, key))
  },
  async onProjectChanged (event, projectId) {
    await dispatch(listMainAreas({ projectId, limit: -1 }, 'mainArea'))
    await dispatch(getUserFromProject(projectId))
    // dispatch(clearFields('defect-list', false, false, 'mainAreaId', 'defectAreaId'))
  },
    async setMainAreaSelected (selected, key) {
    console.log('Check Bug', selected)
    if (selected.length > 0) {
        console.log('In loop', selected)
        dispatch(setMainAreaSelected(selected, key))
        await dispatch(listDefectAreas({ mainAreaId: selected[0].id, limit: -1 }, 'defectArea'))
    }
  },
  clearMainAreaKey (key) {
    dispatch(clearMainAreaKey(key))
  },
  async searchDefectArea (name, mainAreaId, key) {
    dispatch(setDefectAreaIsLoading(true, key))
    await dispatch(listDefectAreas({ name, mainAreaId }, key))
    dispatch(setDefectAreaIsLoading(false, key))
  },
  setDefectAreaSelected (selected, key) {
    dispatch(setDefectAreaSelected(selected, key))
  },
  clearDefectAreaKey (key) {
    dispatch(clearDefectAreaKey(key))
  },
  async searchUser (name, key) {
    dispatch(setUserIsLoading(true, key))
    await dispatch(listUsers({ name }, key))
    dispatch(setUserIsLoading(false, key))
  },
  setUserSelected (selected, key) {
    dispatch(setUserSelected(selected, key))
  },
  clearUserKey (key) {
    dispatch(clearUserKey(key))
  },
  // onExpectedDeliveryDateChanged (value) {
  //   dispatch(setDefectCurrentField('expectedDeliveryDate', value ? value : undefined))
  // },
  goBack () {
    dispatch(goBack())
  },
    async onMainAreaAddSubmit(values) {
        const errors = {}
        if (!values.projectId) {
            errors.projectId = 'Project is required.'
        }
        if (!values.name) {
            errors.name = 'Main area name is required.'
        }
        if (!_.isEmpty(errors)) {
            dispatch(setMainAreaErrors(errors))
            return
        }
        dispatch(clearMainAreaErrors())
        await dispatch(createMainArea({
            ...values
        }))
        await dispatch(listMainAreas({ projectId:values.projectId, limit: -1 }, 'mainArea'))
        dispatch(setIsAddMainArea(false, 'mainArea'))
        // await dispatch(setMainAreaSelected('', 'mainArea'))
    },
    setIsAddMainArea (isAddMainArea, key) {
        dispatch(setIsAddMainArea(isAddMainArea, key))
    },
    setIsAddDefectArea (isAddDefectArea, key) {
        dispatch(setIsAddDefectArea(isAddDefectArea, key))
    },
    async onDefectAreaAddSubmit(values) {
        const errors = {}
        if (!values.mainAreaId) {
            errors.mainAreaId = 'Main area is required.'
        }
        if (!values.name) {
            errors.name = 'Defect area name is required.'
        }
        if (!_.isEmpty(errors)) {
            dispatch(setDefectAreaErrors(errors))
            return
        }
        dispatch(clearDefectAreaErrors())
        await dispatch(createDefectArea({
            ...values
        }))
        await dispatch(listDefectAreas({ mainAreaId:values.mainAreaId, limit: -1 }, 'defectArea'))
        dispatch(setIsAddDefectArea(false, 'defectArea'))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(DefectAddPage)


// WEBPACK FOOTER //
// ./src/containers/DefectAddPage.js